import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Clock, ArrowRight, BookOpen } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RelatedPosts = ({ currentSlug }) => {
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchRelated = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/blogs/${currentSlug}/related`);
        if (!cancelled) setRelated(res.data || []);
      } catch (e) {
        if (!cancelled) setRelated([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    if (currentSlug) fetchRelated();
    return () => { cancelled = true; };
  }, [currentSlug]);

  if (loading) return null;
  if (!related || related.length === 0) return null;

  return (
    <section className="my-16" data-testid="related-posts-section">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center">
          <BookOpen className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-3xl font-bold text-slate-900">Related Articles</h3>
          <p className="text-slate-600">Continue learning with these picks</p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {related.map((blog, idx) => (
          <Link
            key={blog.id || blog.slug}
            to={`/blog/${blog.slug}`}
            className="group bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            data-testid={`related-post-${idx}`}
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={blog.image_url}
                alt={blog.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 bg-teal-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                {blog.category}
              </div>
            </div>
            <div className="p-5">
              <h4 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-teal-600 transition-colors line-clamp-2">
                {blog.title}
              </h4>
              <p className="text-sm text-slate-600 mb-4 line-clamp-2">{blog.excerpt}</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1 text-xs text-slate-500">
                  <Clock className="w-3 h-3" />
                  <span>{blog.reading_time}</span>
                </div>
                <div className="flex items-center gap-1 text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all">
                  Read
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
